import * as React from 'react';

import { ArticleHeading4, UIText1 } from '@cian/ui-kit/typography';

import { IFlatOffers } from '../../../../types/offers';
import { HoveredLink } from '../../../HoveredLink';
import { Link } from '../../../Link';

import * as styles from './styles.css';

interface IOffersRowProps extends IFlatOffers {
  displayHouseName?: boolean;
  onRoomTypeLinkClick(label: string): void;
  onOffersQuantityLinkClick(roomType: string): void;
}

export function OffersRow({
  roomTypeDisplay,
  totalAreaMinDisplay,
  price2Range,
  fromDeveloperPropsCountDisplay,
  offersUrl,
  roomType,
  onRoomTypeLinkClick,
  onOffersQuantityLinkClick,
}: IOffersRowProps) {
  const onClick = React.useCallback(() => onRoomTypeLinkClick(roomType), [roomType]);

  const offersQuantityLinkClick = React.useCallback(() => {
    onOffersQuantityLinkClick(roomType);
  }, []);

  return (
    <div className={styles['container']}>
      <div className={styles['row']}>
        <div className={styles['room-type']}>
          <HoveredLink url={offersUrl} childNode={ArticleHeading4} as="h4" color="black_100" onClick={onClick}>
            {roomTypeDisplay}
          </HoveredLink>
        </div>
        <div>
          <UIText1 color="gray60_100">{totalAreaMinDisplay}</UIText1>
        </div>
        <div className={styles['price']}>
          <UIText1 color="black_100">{price2Range}</UIText1>
        </div>
        <div className={styles['props-count']}>
          <UIText1 color="primary_100">
            <Link onClick={offersQuantityLinkClick} target="_blank" url={offersUrl}>
              {fromDeveloperPropsCountDisplay}
            </Link>
          </UIText1>
        </div>
      </div>
    </div>
  );
}
